import "./FilterComponentsSelectionGuide.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import ComponentsSelectionHero from "./sections/ComponentsSelectionHero";
import FilterCriteria from "./sections/FilterCriteria";
import SelectionGuide from "./sections/SelectionGuide";
import RelatedArticles from "./sections/RelatedArticles";
import QuoteBanner from "./sections/QuoteBanner";
import Footer from "@/reusable_sections/Footer";
export default function FilterComponentsSelectionGuidePage() {
  return <div>
      <Header />
      <PageBreadcrumb page="FilterComponentsSelectionGuide" />
      <ComponentsSelectionHero />
      <FilterCriteria />
      <SelectionGuide />
      <RelatedArticles />
      <QuoteBanner />
      <Footer />
    </div>;
}